import React from 'react';
export var HiperCardArt = _ref => {
  var {
    title
  } = _ref;
  return React.createElement("svg", {
    "aria-labelledby": "hiper-card-art-title",
    "data-testid": "hiper-card-art",
    height: "24",
    role: "img",
    viewBox: "0 0 38 24",
    width: "38",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", {
    id: "hiper-card-art-title"
  }, title), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h38v24H0z",
    fill: "#FFF"
  }), React.createElement("g", {
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M8.311 5.928l15.63-3.736c2.28-.545 4.591.885 5.133 3.179l3.716 15.712a4.295 4.295 0 01-.6 3.36H8.308L5.15 11.09c-.542-2.293.88-4.616 3.161-5.161",
    fill: "#E46C2A"
  }), React.createElement("path", {
    d: "M8.278 12.352v6.713h1.516v-2.809h2.487v2.809h1.506v-6.713h-1.506v2.58H9.794v-2.58H8.278m18.551 4.761c.02-.11.05-.339.05-.598 0-1.205-.595-2.43-2.16-2.43-1.685 0-2.448 1.365-2.448 2.6 0 1.524.941 2.48 2.586 2.48.654 0 1.258-.1 1.754-.299l-.199-1.026c-.406.13-.822.2-1.337.2-.703 0-1.318-.3-1.367-.927h3.12zm-3.131-1.036c.04-.408.297-.986.931-.986.694 0 .852.618.852.986h-1.783zm3.663 2.988h1.506v-2.47c0-.12.01-.24.03-.339.098-.468.475-.767 1.03-.767.168 0 .297.02.406.04v-1.424c-.109-.02-.178-.02-.317-.02-.466 0-1.06.299-1.308 1.006h-.04l-.049-.897h-1.298c.02.419.04.887.04 1.604v3.267",
    fill: "#FFFFFE"
  }), React.createElement("path", {
    d: "M15.318 12.082c.428 0 .775.348.775.778 0 .43-.347.778-.775.778a.776.776 0 01-.774-.778c0-.43.347-.778.774-.778",
    fill: "#FFE80F"
  }), React.createElement("path", {
    d: "M18.499 17.93h.756c.759 0 1.102-.488 1.102-.998s-.036-1.662-.975-1.662c-1.077 0-.902 1.431-.898 2.18.001.16.01.32.015.48zm-3.955-3.742h1.549v2.744c0 .51.28.998.902.999.005-1.236 0-2.508-.042-3.743h1.294c.028.237.054.476.077.715.611-1.229 2.537-.958 3.185.079.67 1.071.897 4.139-2.254 4.139h-.734c.007.623.008 1.247.008 1.87h-1.548c0-.598.004-1.226.008-1.87-1.674-.006-2.445-1.074-2.445-2.189v-2.744z",
    fill: "#FFFFFE"
  })), React.createElement("path", {
    d: "M35 0c1.6 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3H3c-1.6 0-3-1.3-3-3V3c0-1.7 1.3-3 3-3zm0 1H3c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h32c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z",
    fill: "#EDEDED",
    fillRule: "nonzero"
  })));
};
HiperCardArt.defaultProps = {
  title: 'Hiper'
};